<template>
  <div class="container-xxl py-24">
    <AppBreadcrumbs
      :links="[
        {
          text: 'Кабинет',
          alias: '/applicant/interviews'
        },
        {
          text: 'Доп. интервью'
        }
      ]"
    />
    <div
      class="mx-auto"
      style="max-width: 1000px"
    >
      <VideoRecord
        :questions="questions"
        :is-show="isShow"
        :stream="stream"
        :is-update="isUpdate"
        is-interview
        @set-record-blob="setRecordBlob"
        @webm-supported="setWebmSupported"
        @change-question="changeQuestion"
      >
        <template #nextStep>
          <AppButton
            class="fw-bold"
            @click="publication"
          >
            Опубликовать
          </AppButton>
        </template>
      </VideoRecord>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { QuestionRecord } from "~/entities/QuestionRecord";
import { useApiRecordUpload } from "~/composables/api/RecordUpload";
import type { UploadVideoData } from "~/entities/UploadVideoData";
import type {RecordSetRequestDto} from "~/entities/record/RecordSetRequestDto";
import {useVideoSettings} from "~/composables/videoSettings";
import {useCheckMobile} from "~/composables/CheckMobile";

const { $toast } = useNuxtApp();
const route = useRoute();
const router = useRouter();
const apiRecordUpload = useApiRecordUpload();
const client = useClient();

//-----VARIABLES-----\\
let isWebmSupported = true;
let activeQuestion = 0;
let isUpdate = false;

//-----STATE-----\\
const id = ref<string>(route.params.response_id);
const questions = ref<QuestionRecord[]>([]);
const uploadVideoList = useState<UploadVideoData[]>('uploadVideoList');
const isShow = ref(false);
const isMobile = ref<boolean>(false);
const stream = ref<MediaStream>();
const isCameraDenied = ref<boolean>(true);

//-----ASYNC-----\\
if (!client.isAuthenticated) {
  router.push('/');
}

const response = await mainFetch(`responses/${id.value}/answers`);
if (response.error.value !== null || response.data.value.error.code !== 200) {

} else {
  questions.value = response.data.value.additionQuestions.map((val): QuestionRecord => {
    return {
      id: val.id,
      question: val.question,
      hint: val.hint,
      position: val.position,
      type: val.type,
      time: val.time,
      isRequired: val.isRequired,
      answer: val.answer,
      recordBlob: null,
      isLoaded: val.answer !== null,
      isFlip: false,
    };
  });

  if (questions.value[0].isLoaded) {
    isUpdate = true;
  }
}

//-----METHODS-----\\
async function activateCamera() {
  try {
    stream.value = await navigator.mediaDevices.getUserMedia(useVideoSettings(!isMobile));
    isCameraDenied.value = false;
  } catch (err) {
    $toast.error('Не удалось получить доступ к видеокамере и/или микрофону');
    isCameraDenied.value = true;
  }
}
function saveRequest(video: RecordSetRequestDto, isPublished: boolean = false) {
  return mainFetch(`/responses/${id.value}/answers`, {
    method: 'POST',
    body: {
      records: [video],
      isPublished,
    },
  });
}
async function publication() {
  await saveVideo(questions.value[activeQuestion], true);
}
function setRecordBlob(index: number, value: Blob|null) {
  questions.value[index].recordBlob = value;
  questions.value[index].answer = null;
}
function setWebmSupported(val: boolean) {
  isWebmSupported = val;
}

function goToMainPage() {
  router.push('/applicant/interviews');
}
async function saveVideo(video: QuestionRecord, isLast: boolean = false) {
  if (video.isLoaded) {
    return;
  }

  let hash = null;
  if (video.recordBlob !== null) {
    if (video.recordBlob?.size === 0) {
      $toast.error('Файл записанного видео поврежден');
      console.error('Blob size == 0');

      return;
    }

    hash = await apiRecordUpload.getHash(video.recordBlob);
  }

  const response = await saveRequest(
    {
      id: video.answer?.id??null,
      questionId: video.id,
      hash: hash
    },
    isLast
  );
  if (response.error.value !== null || response.data.value.error.code !== 200) {
    $toast.error('При сохранении видео возникла непредвиденная ошибка');
    console.error('SaveVideo get token error', response);

    return;
  }

  video.isLoaded = true;

  if (hash === null) {
    if (isLast) {
      goToMainPage();
    }

    return;
  }

  uploadVideoList.value.push({
    token: response.data.value.recordToken,
    answerId: response.data.value.records[0].answerId,
    isVacancy: true,
    file: video.recordBlob!,
    isFlip: video.isFlip,
    isWebm: isWebmSupported,
    upload: {
      status: 0,
      size: {
        loaded: null,
        total: null,
      },
    },
  });

  if (isLast) {
    goToMainPage();
  }
}
function changeQuestion(old: number, next: number) {
  activeQuestion = next;

  saveVideo(questions.value[old], next === questions.value.length - 1);
}

onMounted(() => {
  isMobile.value = useCheckMobile();
  isShow.value = true;
  activateCamera();
});
</script>

<style lang="scss">
</style>